// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JSbE","name":"styles_name__3FHap","phone":"styles_phone__1Hdo0"};